import React from "react"
import {GetMetaTable} from "./utils/table_helpers";
import {FormatHeaderText} from "./utils/table_formatters"

export default function SampleTableHeader(props){
	const headerCells = GetMetaTable(props.reportType).map((header, index) => {
		return <th key={`${index}_${header.name}`}>{FormatHeaderText(header.headerText)}</th>
	})
	
	return(
		<thead>
			<tr>
				{headerCells}
			</tr>
		</thead>
	)
}